import { Skeleton } from '@growdash/design-system/atoms';

type Props = {};

export default function BrandMenuSkeleton({}: Props) {
  return (
    <div className="p-4">
      <div className="w-full grid grid-cols-4 gap-4 gap-y-4 animate-fade-in">
        {Array.from({ length: 16 }).map((_, index) => (
          <Skeleton
            key={index}
            className="h-32 rounded-lg overflow-hidden"
            style={{ width: '100%' }}
          />
        ))}
      </div>
    </div>
  );
}
